<template>
  <nuxt-link
    class="notification-panel__notification-link"
    :to="route"
    @click="markAsReadAndHandleClick"
  >
    <div class="notification-panel__notification-content-title">
      <i18n-t keypath="conversationProposedNotification.title" tag="span">
        <template #agent>
          <strong>{{ notification.data.agent || $t('conversationProposedNotification.theAi') }}</strong>
        </template>
        <template #count>
          <strong>{{ notification.data.count }}</strong>
        </template>
        <template #table>
          <strong>{{ notification.data.table_name }}</strong>
        </template>
        <template #label>
          <strong>{{ notification.data.source_label || $t('conversationProposedNotification.audio') }}</strong>
        </template>
      </i18n-t>
    </div>
    <div class="notification-panel__notification-content-desc">
      {{ $t('conversationProposedNotification.hint') }}
    </div>
  </nuxt-link>
</template>

<script>
import notificationContent from '@baserow/modules/core/mixins/notificationContent'

export default {
  name: 'ConversationProposedNotification',
  mixins: [notificationContent],
  emits: ['close-panel'],
  methods: {
    handleClick() {
      this.$emit('close-panel')
    },
  },
}
</script>
